import React from 'react';

function CoursesPage() {
  return (
    <div>
      <header>
        <h1>Cursos de EduSol</h1>
        <p>Explora nuestra amplia gama de cursos y mejora tus habilidades.</p>
      </header>
      <main>
        <section>
          <h2>Todos los Cursos</h2>
          {/* Componente que lista todos los cursos disponibles */}
        </section>
      </main>
    </div>
  );
}

export default CoursesPage;
